import type {GetHovercardAttributesForTypeFn} from './use-get-hovercard-attributes-for-type'

export type ReviewerHovercard =
  | {type: 'copilot'; botSlug: string}
  | {type: 'automated_reviewer'; botSlug: string}
  | {type: 'user'; login: string}
  | {type: 'team'; owner: string; team: string}

export function getReviewerHovercardAttributes(
  hovercard: ReviewerHovercard | undefined,
  getHovercardAttributesForType: GetHovercardAttributesForTypeFn,
) {
  if (!hovercard) return {}

  switch (hovercard.type) {
    case 'copilot':
      return getHovercardAttributesForType('copilot', {botSlug: hovercard.botSlug})
    case 'automated_reviewer':
      return getHovercardAttributesForType('automated_reviewer', {botSlug: hovercard.botSlug})
    case 'user':
      return getHovercardAttributesForType('user', {login: hovercard.login})
    case 'team':
      return getHovercardAttributesForType('team', {owner: hovercard.owner, team: hovercard.team})
    default:
      return {}
  }
}
